/*
 * $Id:: FooterMobile.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';

import { globals as globalsSlice } from '../../app/globalsSlice';
import EUIPNLogo from '../../assets/images/logo_euipn.svg';
import logorepublica from '../../assets/images/logo_republica.svg';
import logojustica from '../../assets/images/logojustica.svg';
import { t } from '../../providers/TranslationProvider';
import ExternalLinks from '../ExternalLinks';
// import ExpandedSection from './ExpandedSection';

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: theme.palette.action.footerGrey,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '30px 21vw',
        '@media (max-width:600px)': {
            padding: '0px 16px 30px 16px',
        },
        '& svg': {
            fill: theme.palette.text.outlined,
        },
    },
    expandedSection: {
        marginTop: '20px',
    },
    expansionPanel: {
        backgroundColor: 'transparent',
        boxShadow: 'unset',
    },
    expansionPanelSummary: {
        borderBottom: '3px solid' + theme.palette.text.outlined,
        padding: 'unset',
    },
    expandedSectionTitle: {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.titleFontWeight,
        fontSize: theme.typography.titleFontSize,
    },
    expandedSectionContent: {
        padding: '8px 0 0 0',
    },
    footerLinkLg: {
        color: '#ffffff',
        fontSize: '0.875rem',
        fontWeight: 'normal',
        textDecorationLine: 'none',
        paddingBottom: '5px',
        cursor: 'pointer',
        marginRight: '50px',
        '@media (max-width:280px)': {
            fontSize: '0.6875rem',
        },
    },
    info: {
        color: '#ffffff',
    },
    infoItem: {
        lineHeight: '20px',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '0.875rem',
        letterSpacing: 'normal',
        textAlign: 'center',
    },
    footerversion: {
        float: 'right',
        fontSize: '0.75rem',
        opacity: '.5',
    },
    informationLinksCol: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    section: {
        marginTop: '30px',
    },
    social: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '18px',
    },
    socialBtn: {
        paddingRight: '20px',
    },
    logo: {
        display: 'flex',
        justifyContent: 'center',
        '@media (max-width:600px)': {},
        '& svg': {
            maxWidth: '383px',
            width: '100%',
        },
    },
    appVersion: {
        textAlign: 'center',
    },
    footerLinks: {
        paddingLeft: '60px',
        textAlign: 'center',
        '@media (max-width:600px)': {
            paddingLeft: '45px',
        },
        '@media (max-width:320px)': {
            paddingLeft: '12px',
        },
        '@media (max-width:280px)': {
            paddingLeft: '10px',
        },
    },
}));

// const useStylesFooterTitle = makeStyles((theme) => ({
//     title: {
//         color: '#455A64',
//         fontWeight: theme.typography.titleFontWeight,
//         fontSize: theme.typography.titleFontSize,
//         borderBottom: '3px solid' + theme.palette.text.outlined,
//         paddingBottom: '15px',
//     },
// }));

// const FooterTitle = ({ title }) => {
//     const classes = useStylesFooterTitle();
//     return <Typography className={classes.title}>{title}</Typography>;
// };

const FooterMobile = () => {
    const classes = useStyles();
    const { globals } = useSelector(globalsSlice) || {};

    // const preventDefault = (event) => event.preventDefault();

    const footerExternalLinks = globals && globals.footer && Object.values(globals.footer);
    const d = new Date();
    const year = d.getFullYear();

    return (
        <div className={classes.footer}>
            <div className={classes.section}>
                <div className={`${classes.info} ${classes.section}`}>
                    <div className={[classes.section, classes.logo].join(' ')}>
                        <a
                            aria-label={t('go.to.euipo')}
                            href={globals.ipo['euipo.image.url']}
                            target={'_blank'}
                            style={{ marginTop: '23.19px' }}
                            rel="noopener noreferrer"
                            title={t('open.new.tab')}>
                            <img src={EUIPNLogo} alt={t('footer.euipn.logo')} />
                        </a>
                    </div>
                </div>
                <div className={`${classes.info} ${classes.section}`}>
                    <div className={[classes.section, classes.logo].join(' ')}>
                        <a
                            aria-label={t('go.to.justice')}
                            href={globals.ipo['justica.gov.image.url']}
                            target={'_blank'}
                            style={{ marginTop: '29.5px' }}
                            rel="noopener noreferrer"
                            title={t('open.new.tab')}>
                            <img src={logojustica} alt={t('footer.justice.logo')} />
                        </a>
                    </div>
                </div>
                <div className={`${classes.info} ${classes.section}`}>
                    <div className={[classes.section, classes.logo].join(' ')}>
                        <a
                            aria-label={'go.to.government'}
                            href={globals.ipo['republica.portuguesa.image.url']}
                            target={'_blank'}
                            rel="noopener noreferrer"
                            title={t('open.new.tab')}>
                            <img src={logorepublica} alt={t('footer.republic.logo')} />
                        </a>
                    </div>
                </div>
            </div>

            {/* About EUIPN */}
            <div className={`${classes.footerLinks} ${classes.section}`}>
                <ExternalLinks links={footerExternalLinks} className={classes.footerLinkLg} />
            </div>

            {/* Contact information */}
            <div className={classes.section}>
                <div className={`${classes.info}`}>
                    <Typography variant={'subtitle2'} className={classes.infoItem} component={'div'}>
                        {year} | Instituto Nacional da Propriedade Industrial
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default FooterMobile;
